import React from 'react';
import { useSelector } from 'react-redux';
import Dashlet from '../components/features/Dashlet.jsx';
import { LanguageLoader } from '../assets/languages/index.js';

const Dashboard = () => {
	const settings = useSelector((state) => state.settings);
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	return(
		<React.Fragment>
			{settings.messages && settings.messages.general && settings.messages.general.length ?
				<div className="wrapper" dangerouslySetInnerHTML={{__html: settings.messages.general}}></div>
			: null}
			{settings.dashlets.basic && settings.dashlets.basic.length ?
				<div className="grid md:grid-flow-col gap-x-4">
					{settings.dashlets.basic.map((data, index) => {
						return <Dashlet key={index} type='basic' data={data}/>
					})}
				</div>
			: null}
			{settings.dashlets.chart && settings.dashlets.chart.length ?
				<div className="grid min-[1600px]:grid-cols-4 xl:grid-cols-3 md:grid-cols-2 gap-x-4">
					{settings.dashlets.chart.map((data, index) => {
						return <Dashlet key={index} type='chart' data={data}/>
					})}
				</div>
			: null}
			{!settings.dashlets.chart && !settings.dashlets.basic ?
				<div>{language.NO_DASHLET}</div>
			: null}
		</React.Fragment>
	);
}

export default Dashboard;